import { apiClient } from './apiClient';

export const getAdmins = async () => {
  return await apiClient('/admin/admins', { method: 'GET' }, true);
};

export const createAdmin = async (payload) => {
  return await apiClient('/admin/admins', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, true);
};

export const changeMyPassword = async (currentPassword, newPassword) => {
  return await apiClient('/admin/me/password', {
    method: 'PATCH',
    body: JSON.stringify({ currentPassword, newPassword }),
  }, true);
};

export const getRoleLabel = (role) => {
  const map = { CEO: '대표', GENERAL: '일반 관리자' };
  return map[role] || role;
};